import { render, staticRenderFns } from "./AparelhoSimilarImagem.vue?vue&type=template&id=24c9532f&scoped=true&"
import script from "./AparelhoSimilarImagem.vue?vue&type=script&lang=js&"
export * from "./AparelhoSimilarImagem.vue?vue&type=script&lang=js&"
import style0 from "./AparelhoSimilarImagem.vue?vue&type=style&index=0&id=24c9532f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c9532f",
  null
  
)

export default component.exports